import React from 'react'
import {
  CategoriesSwitcherWrapper,
  FeaturedButton
} from './CategoriesSwitcher.styles'

export const CategoriesSwitcher = ({ list, selected, onChange }) => {
  return (
    <CategoriesSwitcherWrapper>
      {list.map(category => (
        <FeaturedButton
          selected={category.label === selected.label}
          onClick={() => {
            onChange(category)
          }}
          key={category.label}
        >
          {category.label}
        </FeaturedButton>
      ))}
    </CategoriesSwitcherWrapper>
  )
}
